import { useQuery } from "@tanstack/react-query";
import { createPlaceEnquiryServices } from "../services/placeEnquiryServices";

export function usePlaceEnquiryData(apiBaseUrl: string, authToken: string) {
  const services = createPlaceEnquiryServices(apiBaseUrl, authToken);

  const carMakers = useQuery({
    queryKey: ["placeEnquiry", "carMakers", apiBaseUrl],
    queryFn: () => services.getCarMakers(),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: Infinity,
  });

  const stateCity = useQuery({
    queryKey: ["placeEnquiry", "stateCity", apiBaseUrl],
    queryFn: () => services.getStateCity(),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: Infinity,
  });

  const insurers = useQuery({
    queryKey: ["placeEnquiry", "insurers", apiBaseUrl],
    queryFn: () => services.getInsurers(),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: Infinity,
  });

  const brands = useQuery({
    queryKey: ["placeEnquiry", "brands", apiBaseUrl],
    queryFn: () => services.getBrands(),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: Infinity,
  });

  const insuranceSpocUsers = useQuery({
    queryKey: ["placeEnquiry", "insuranceUsers", "SPOC", apiBaseUrl],
    queryFn: () => services.getInsuranceUsers("SPOC"),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: 5 * 60 * 1000,
  });

  const insuranceSurveyorUsers = useQuery({
    queryKey: ["placeEnquiry", "insuranceUsers", "SURVEYOR", apiBaseUrl],
    queryFn: () => services.getInsuranceUsers("SURVEYOR"),
    enabled: !!apiBaseUrl && !!authToken,
    staleTime: 5 * 60 * 1000,
  });

  return {
    carMakersData: carMakers.data,
    isLoadingCarMakers: carMakers.isLoading,
    stateCityData: stateCity.data,
    isLoadingStateCity: stateCity.isLoading,
    insurersData: insurers.data,
    isLoadingInsurers: insurers.isLoading,
    brandsData: brands.data,
    isLoadingBrands: brands.isLoading,
    insuranceSpocUsers: insuranceSpocUsers.data,
    insuranceSurveyorUsers: insuranceSurveyorUsers.data,
    isLoadingInsuranceSpocUsers: insuranceSpocUsers.isLoading,
    isLoadingInsuranceSurveyorUsers: insuranceSurveyorUsers.isLoading,
    services,
  };
}
